import { render } from "./HeroiconsSolidColorSwatch.vue?vue&type=template&id=bf63c686"
const script = {}

import exportComponent from "/home/tobias/Desktop/screenads/nova-custom2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidColorSwatch.vue"]])

export default __exports__